export default "__VITE_ASSET__CjMWm6aR__"